define(['angular', '../module'], function(angular, MODULE_NAME) {
    'use strict';

    angular.module(MODULE_NAME)
        .directive('ilmnUiNav', UiNavDirective);

    UiNavDirective.$inject = ['$rootScope'];
    function UiNavDirective($rootScope) {
        return {
            restrict: 'A',
            link: function(scope,elem) {
                var menuItemWidth;
                var marker = $('<li class="hidden-xs marker"></li>');

                elem.append(marker);

                $rootScope.$on('$stateChangeSuccess', function() {
                    $rootScope.$applyAsync(function() {
                        slideToActive(marker, elem);
                    })
                });

                elem.find('.navbar-menu-item')
                    .on('mouseover', function() { pingPongAnimation(marker, this); })
                    .on('mouseout', function() { slideToActive(marker, elem); })


                ////////////

                function pingPongAnimation(marker, menuItem) {
                    if(typeof menuItem === 'undefined') {
                        marker.css({opacity: 0})
                    }
                    else {
                        menuItemWidth =  $(menuItem).width();

                        marker.css({
                            opacity: 0.35,
                            left: $(menuItem).position().left + "px",
                            width: $(menuItem).width() + "px"
                        });
                    }

                }

                function slideToActive(marker, listId) {
                    var list = $(listId);
                    var hasActive = false;
                    var childItems = list.children(':visible');

                    if(childItems.length) {
                        for(var i = 0; i < (childItems.length - 1); i++) {
                            if( $(childItems[i]).hasClass("active") ){
                                pingPongAnimation(marker, childItems[i]);
                                hasActive = true;
                                $(childItems[i]).css("width", menuItemWidth + "px");
                            } else {
                                $(childItems[i]).css("width", "initial");
                            }
                        }
                        if(!hasActive) {
                            pingPongAnimation(marker);
                        }
                    }
                }
            }
        }
    }
})



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-nav/scripts/nav.directive.js
// module id = 7
// module chunks = 0